// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BAZAAR_OF_username = "Bazar u\u017eivatelky %(username)s";
export const BAZAAR_SEO_BABY = "Bazar";
export const CONFIRM = "Potvr\u010f";
